import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { AddNameForm } from './add_name_form';

export class AddNameFormExpander extends Component {
  constructor(props) {
    super(props);
    this.state = { form: 'collapsed' };
  }

  render() {
    if (this.props.isError || this.state.form === 'expanded') {
      return this.renderNameInput();
    } else {
      return this.renderAddAnotherName();
    }
  }

  renderAddAnotherName() {
    return (
      <span
        className="u-fs16 u-fw500 u-lineHeight1 u-tcBlue u-clickable"
        onClick={this.expand}
      >
        + Add Alternate Name
      </span>
    );
  }

  renderNameInput() {
    return (
      <AddNameForm
        onAdd={this.addName}
        onCancel={this.cancel}
        onClearAddNameErrors={this.clearAddNameErrors}
        buttonText="ADD NAME"
        errorMessage={this.props.errorMessage}
        modalMode={this.props.modalMode}
      />
    );
  }

  expand = () => {
    this.setState({ form: 'expanded' });
  };

  clearAddNameErrors = () => {
    // callback to clear backend error messages
    this.props.onClearAddNameErrors();
    this.expand();
  };

  cancel = () => {
    // callback to clear backend error messages when cancel is pressed
    this.props.onCancel();
    this.setState({ form: 'collapsed' });
  };

  addName = (firstName, middleName, lastName) => {
    this.props.onAdd(firstName, middleName, lastName);
    this.setState({ form: 'collapsed' });
  };
}
AddNameFormExpander.propTypes = {
  onAdd: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onClearAddNameErrors: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
  isError: PropTypes.bool.isRequired,
  modalMode: PropTypes.bool,
};
AddNameFormExpander.defaultProps = {
  modalMode: false,
};

export default AddNameFormExpander;
